<template>
  <div class="app-container">
    <el-card v-loading="loading">
      <div slot="header">
        <span>客服详情</span>
        <el-button style="float: right;" type="primary" size="small" @click="goBack">返回</el-button>
      </div>
      <el-form label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服ID">
              <span>{{ agent.agentId }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客服编号">
              <span>{{ agent.agentNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="登录账号">
              <span>{{ agent.loginCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客服名称">
              <span>{{ agent.agentName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="显示名称">
              <span>{{ agent.displayName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门">
              <span>{{ agent.departmentName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮箱">
              <span>{{ agent.email }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话">
              <span>{{ agent.phone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-tag :type="agent.status === 'online' ? 'success' : 'info'">{{ agent.status }}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色">
              <el-tag>{{ agent.role }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="当前会话数">
              <span>{{ agent.currentConversationCount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大并发数">
              <span>{{ agent.maxConcurrent }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="权重">
              <span>{{ agent.weight }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              <span>{{ agent.createdAt | parseTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getAgent } from '@/api/agent'

export default {
  name: 'AgentDetail',
  filters: {
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      agent: {},
      loading: false
    }
  },
  created() {
    this.loadAgent()
  },
  methods: {
    async loadAgent() {
      const agentId = this.$route.params.id
      this.loading = true
      try {
        const res = await getAgent(agentId)
        this.agent = res.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.push('/agent/list')
    }
  }
}
</script>

<style scoped>
</style>